import { render, staticRenderFns } from "./LeagueImg.vue?vue&type=template&id=7ff3a6f6&scoped=true"
import script from "./LeagueImg.vue?vue&type=script&lang=js"
export * from "./LeagueImg.vue?vue&type=script&lang=js"
import style0 from "./LeagueImg.vue?vue&type=style&index=0&id=7ff3a6f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff3a6f6",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Img: require('/skade-pwa/components/ui/atom/Img.vue').default})
